<template>
  <div class="text-dark overflow-x-hidden m-0 p-0 flex flex-col min-h-screen bg-light-gray">
    <main class="title_style flex-grow pb-4">
      <section class="relative overflow-hidden bg-grid py-16 bg-lighter">
        <!-- 背景装饰 -->
        <div class="absolute inset-0 z-0">
          <div class="absolute top-1/4 right-1/4 w-96 h-96 lg:h-full bg-tab_primary/10 rounded-full filter blur-3xl animate-pulse-slow" />
          <div class="absolute bottom-1/3 left-1/4 w-96 h-96 lg:h-full bg-tab_secondary/10 rounded-full filter blur-3xl animate-pulse-slow" style="animation-delay: 2s;" />
        </div>

        <div class="container mx-auto px-4 relative z-10">
          <div class="max-w-3xl mx-auto text-center">
            <h1 class="text-2xl md:text-4xl font-bold mb-6 text-reveal">
              新闻<span class="bg-gradient-to-r from-primary to-secondary text-gradient gradient-flow">动态</span>
            </h1>
            <p class="text-xl text-gray-300 max-w-2xl mx-auto font-bold">NEWS</p>
          </div>
        </div>
      </section>
    </main>

    <!-- 主要内容 -->
    <main class="flex-grow lg:px-56">

      <!-- 新闻内容区域 -->
      <section class="container mx-auto px-4">
        <!-- 新闻分类 -->
        <div class="mb-12 overflow-x-auto pb-4">
          <div class="flex gap-3 min-w-max text-reveal mb-4">
            <button class="category-tag active px-5 py-2 rounded-full border border-gray-200 transition-all duration-300 whitespace-nowrap">
              全部新闻
            </button>
          </div>

          <!-- 新闻列表 -->
          <div class="flex flex-col gap-8 mb-16">
            <!-- 新闻卡片 -->
            <div
              v-for="(d, i) in news_data"
              :key="i"
              class="bg-white rounded-xl overflow-hidden news-card-hover card-reveal flex flex-col md:flex-row shadow-sm"
            >
              <router-link :key="i" :to="{path: '/index/newInfo', query: {id: d.id}}" style="display: contents">
                <img :src="filePath + d.i" alt="" class="w-full md:w-1/3 h-64 md:h-60 object-cover">
                <div class="p-6 md:p-8 flex-1 flex flex-col justify-center">
                  <div class="flex flex-wrap gap-2 mb-3">
                    <span class="inline-flex items-center gap-1 text-gray-500 text-md">
                      <i class="fa fa-calendar" /> {{ format_date(d.rt) }}
                    </span>
                  </div>
                  <h3 class="text-2xl font-bold mb-3">{{ d.n }}</h3>
                  <p class="text-gray-600 mb-4">{{ d.c }}</p>
                  <a href="#" class="read-more inline-flex items-center gap-2 text-primary hover:text-secondary transition-colors mt-auto">
                    查看详情 <i class="fa fa-angle-right" />
                  </a>
                </div>
              </router-link>
            </div>
          </div>

          <!-- 分页 -->
          <div class="flex justify-center items-center gap-2 text-reveal">
            <button
              v-if="page.pageNum > 1"
              class="pagination-btn w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center hover:text-primary transition-colors"
              @click="get_news_data_del"
            >
              <i class="fa fa-angle-left" />
            </button>
            <button
              v-for="(d, index) in page.totalPage"
              id="page"
              :key="index"
              class="pagination-btn w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center"
              :class="{ 'active': count === d }"
            >
              <a @click="get_news_data_change(d)">{{ d }}</a>
            </button>
            <button
              v-if="page.pageNum < page.totalPage"
              class="pagination-btn w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center hover:text-primary transition-colors"
              @click="get_news_data_add"
            >
              <i class="fa fa-angle-right" />
            </button>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import vv from '@/components/varVariable'
import { get_news_introduction_page } from '@/api/news'

export default {
  name: 'News',
  data() {
    return {
      selectedIndex: -1,
      count: 1,
      loading: false,
      page: {
        pageNum: 1,
        pageSize: 3,
        total: 0,
        totalPage: 0
      },
      news_data: [],
      new_news_data: [{
        id: 1,
        i: '',
        t: '',
        c: '',
        d: ''
      }]
    }
  },
  computed: {
    filePath() {
      return vv.fileHttp
    },
    no_more() {
      return this.news_data.length >= this.page.total
    },
    disabled() {
      return this.loading || this.noMore
    }
  },
  created() {
    this.get_news_data()
  },
  mounted() {
    this.handleScroll()
  },
  methods: {
    get_news_data() {
      this.news_data.splice(0)
      this.loading = true
      const selectPage = {
        langType: 'zh',
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize
      }
      get_news_introduction_page(selectPage).then(data => {
        console.log(data)
        this.page.total = data.totalNum
        this.page.pageNum = data.pageNum
        this.page.pageSize = data.pageSize
        this.page.totalPage = data.totalPage
        const dl = data.d.length
        for (let i = 0; i < dl; i++) {
          this.news_data.splice(this.news_data.length, 0, data.d[i])
        }
      }).finally(() => {
        this.loading = false
      })
    },
    get_news_data_change(d) {
      this.count = d
      this.page.pageNum = d
      this.get_news_data()
    },
    get_news_data_add() {
      this.count = this.count >= this.page.totalPage ? this.page.totalPage : this.count + 1
      this.page.pageNum = this.count
      this.get_news_data()
    },
    get_news_data_del() {
      this.count = this.count === 1 ? 1 : this.count - 1
      this.page.pageNum = this.count
      this.get_news_data()
    },
    handleSelect(index) {
      this.selectedIndex = index
    },
    format_date(t) {
      /* HH:mm:ss*/
      return this.$moment(new Date(t)).format('YYYY-MM-DD')
    }
  }
}
</script>

<style scoped>
/* 组件内样式补充 */
.active {
  @apply shadow-lg;
}

.title_style {
  @media screen and (max-width: 800px){
    padding-top: 4.3rem;
  }
  @media screen and (min-width: 800px){
    padding-top: 6rem;
  }
}
</style>
